//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapState, mapMutations } from 'vuex'
  import { orderList, userInfo } from '@/service/index'

  import Order from '@/components/order/Order.vue'

  export default {
    data () {
      return {
        userInfo: {},
        orderList: [],
        isLoading: true,
        profileHead: require('../../assets/default-avatar.png'),
        profileHeadMb: require('../../assets/default-avatar.png')
      }
    },
    components: {
      Order
    },
    mounted () {
      this.getOrderList()
      this.getUserInfo()
      this.keepLang()
    },
    computed: {
      ...mapState(['global', 'campaign']),
      getNoPaiedOrder () {
        return this.orderList.filter(order => order.status === 1)
      },
      getPaiedOrder () {
        return this.orderList.filter(order => order.status === 2)
      }
    },
    methods: {
      async getOrderList () {
        const res = await orderList(this.$route.query.cid)
        this.isLoading=false
        if (res.status === 0) {
          this.orderList = res.data
        }
      },
      async getUserInfo () {
        const res = await userInfo(this.$route.query.cid)
        if (res.status === 0) {
          this.userInfo = res.data
        }
      },
      cancel(order) {
        order.status = 12
      },
      keepLang(){
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
    }
  }



// WEBPACK FOOTER //
// ./src/pages/my/Order.vue